'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import StaffCal from './staffCal';

class StaffBody extends React.Component {
    constructor(props) {
        super(props);

    }
    static defaultProps = {
        monthTxt: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    };

    render() {
        let year = this.props.selectedYear ? this.props.selectedYear : new Date().getFullYear();
        let month = typeof this.props.selectedMonth == 'number' ? this.props.selectedMonth : new Date().getMonth();

        let start_day = new Date(year, month, 1).getDay();
        let last_date = new Date(year, month + 1, 0).getDate();
        let last_wk = Math.ceil((last_date + start_day) / 7);

        return (
            <div className="cal-bd-wp">
                <div className="atd-bd-tt">
                    <h3><b>
                        {this.props.staffAtd ? this.props.staffAtd.userName : ""} &nbsp;
                        ({this.props.monthTxt[this.props.selectedMonth] + " " + this.props.selectedYear})
                    </b></h3>
                </div>
                <div className="cal-bd">
                    <table className="cal-tb">
                        <thead>
                            <tr>
                                <th>Sun</th>
                                <th>Mon</th>
                                <th>Tue</th>
                                <th>Wed</th>
                                <th>Thu</th>
                                <th>Fri</th>
                                <th>Sat</th>
                            </tr>
                        </thead>
                        <StaffCal
                            holiday={this.props.holiday}
                            year={this.props.selectedYear}
                            month={this.props.selectedMonth}
                            staffAtd={this.props.staffAtd}
                            start_day={start_day}
                            last_date={last_date}
                            last_wk={last_wk}
                        />
                    </table>
                </div>
            </div>
        );
    }
}
export default StaffBody;


// WEBPACK FOOTER //
// ./app/components/attdComponents/staffBody.js